module.exports = __webpack_public_path__ + "img/hw-cover.5820d337.png";